import React from 'react';

import { useAppSelector } from 'hooks/storeHooks';

type CompareType = 'max' | 'min';

export const useBreakpoint = () => {
  const windowWidth = useAppSelector((state) => state.application.windowWidth);

  const checkWidth = React.useCallback(
    (value: number, type: CompareType = 'max') => {
      if (type === 'min') {
        return windowWidth >= value;
      }
      return windowWidth < value;
    },
    [windowWidth],
  );

  return checkWidth;
};
